import * as React from "react";
import { useSwipeable } from "react-swipeable";
import { CSSTransition } from "react-transition-group";
import { UitkTertiaryButton } from "../uitk-react-button/index.js";
import { classNames, Level, liveAnnounce, throttle } from "../uitk-react-utils/index.js";
export var TimerSetting = /* @__PURE__ */ ((TimerSetting2) => {
  TimerSetting2[TimerSetting2["long"] = 4500] = "long";
  TimerSetting2[TimerSetting2["short"] = 3e3] = "short";
  return TimerSetting2;
})(TimerSetting || {});
const Swipeable = ({
  children,
  className,
  ...props
}) => {
  const handlers = useSwipeable(props);
  const parentClasses = classNames(className, "uitk-toast", "uitk-toast-slide");
  return /* @__PURE__ */ React.createElement("div", { className: parentClasses, ...handlers }, children);
};
export class UitkToast extends React.PureComponent {
  static displayName = "UitkToast";
  timedToast;
  toastRef;
  actionRef;
  static defaultProps = {
    action: false,
    show: false
  };
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      stateIsDerived: false
    };
    this.toastRef = React.createRef();
    this.actionRef = React.createRef();
    this.dismissToast = this.dismissToast.bind(this);
    this.manuallyDismissToast = this.manuallyDismissToast.bind(this);
    this.clearTimer = this.clearTimer.bind(this);
    this.onEntered = this.onEntered.bind(this);
    this.onEntering = this.onEntering.bind(this);
    this.onExit = this.onExit.bind(this);
    this.onExited = this.onExited.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.liveAnnounceMsg = this.liveAnnounceMsg.bind(this);
    this.handleScroll = throttle(100, this.handleScroll.bind(this));
  }
  componentDidUpdate() {
    const { show } = this.state;
    if (!show) {
      this.clearTimer();
    }
  }
  componentWillUnmount() {
    this.clearTimer();
    window.removeEventListener("scroll", this.handleScroll);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const show = !prevState.stateIsDerived && !prevState.show ? false : nextProps.show;
    return {
      show,
      stateIsDerived: true
    };
  }
  handleScroll() {
    window.removeEventListener("scroll", this.handleScroll);
    this.startTimer();
  }
  onExit() {
    const { props } = this;
    if (props.verticalOffset) {
      const offset = props.verticalOffset;
      this.toastRef.current.parentElement.style.transform = `translateY(-${offset + 150}px)`;
    }
  }
  onExited() {
    this.resetLiveAnnounceMsg();
  }
  onExiting() {
    const { props } = this;
    if (props.verticalOffset) {
      const offset = props.verticalOffset;
      this.toastRef.current.parentElement.style.transform = `translateY(${offset}px)`;
    }
  }
  onEntered() {
    this.setFocusAndLiveAnnounce();
    const { props } = this;
    if (props.verticalOffset) {
      const offset = props.verticalOffset;
      this.toastRef.current.parentElement.style.transform = `translateY(-${offset}px)`;
    }
  }
  onEntering() {
    const { props } = this;
    if (props.verticalOffset) {
      const offset = props.verticalOffset;
      this.toastRef.current.parentElement.style.transform = `translateY(-${offset + 150}px)`;
    }
  }
  setFocus(ref) {
    if (ref && ref.current) {
      ref.current.focus();
    }
  }
  setFocusAndLiveAnnounce() {
    const { actionCallback, actionText } = this.props;
    if (actionText && actionCallback) {
      this.setFocus(this.actionRef);
      setTimeout(() => this.liveAnnounceMsg(), 0);
      window.addEventListener("scroll", this.handleScroll);
    } else {
      this.liveAnnounceMsg();
      this.startTimer();
    }
  }
  clearTimer() {
    if (this.timedToast) {
      clearTimeout(this.timedToast);
    }
  }
  startTimer() {
    const { props } = this;
    let timer;
    if (props.timeDisplayed) {
      timer = props.timeDisplayed;
    } else {
      timer = props.actionText && props.actionCallback ? 4500 /* long */ : 3e3 /* short */;
    }
    this.clearTimer();
    this.timedToast = setTimeout(() => {
      this.dismissToast();
    }, timer);
  }
  resetLiveAnnounceMsg() {
    liveAnnounce("", Level.POLITE);
  }
  liveAnnounceMsg() {
    const { children } = this.props;
    let message;
    React.Children.map(children, (child) => {
      if (child) {
        message = child;
      }
    });
    liveAnnounce(message, Level.POLITE);
  }
  isInViewport(element) {
    const { bottom, left, right, top } = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (top >= 0 && left >= 0 && right <= viewportWidth && bottom <= viewportHeight) {
      return true;
    }
    return false;
  }
  hasManuallyFocused() {
    if (document.activeElement && document.activeElement !== this.toastRef.current && document.activeElement !== this.actionRef.current && document.activeElement.tagName !== "BODY") {
      return true;
    }
    return false;
  }
  dismissToast() {
    const { onCloseRef, onDismiss } = this.props;
    const { show } = this.state;
    if (show && typeof onDismiss === "function" && onDismiss) {
      onDismiss();
    }
    if (onCloseRef && onCloseRef.current && this.isInViewport(onCloseRef.current) && !this.hasManuallyFocused()) {
      this.setFocus(onCloseRef);
    }
    this.clearTimer();
    this.setState({
      show: false,
      stateIsDerived: false
    });
    window.removeEventListener("scroll", this.handleScroll);
  }
  manuallyDismissToast() {
    const { actionCallback } = this.props;
    if (actionCallback) {
      actionCallback();
    }
    this.dismissToast();
  }
  render() {
    const { actionCallback, actionText, children } = this.props;
    const { show } = this.state;
    const action = !!(actionText && actionCallback);
    const actionBtnParentClass = classNames("uitk-type-right");
    const labelClasses = classNames("uitk-toast-content");
    return /* @__PURE__ */ React.createElement(
      CSSTransition,
      {
        classNames: {
          appear: classNames("uitk-toast-appear"),
          appearActive: classNames("uitk-toast-appear-active"),
          enter: classNames("uitk-toast-enter"),
          enterActive: classNames("uitk-toast-enter-active"),
          enterDone: classNames("uitk-toast-enter-done"),
          exit: classNames("uitk-toast-exit"),
          exitActive: classNames("uitk-toast-exit-active")
        },
        delay: "0",
        duration: "500",
        appear: true,
        mountOnEnter: false,
        in: show,
        unmountOnExit: true,
        timeout: {
          enter: 300,
          exit: 500
        },
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExited: this.onExited,
        onExiting: this.onExiting
      },
      /* @__PURE__ */ React.createElement(Swipeable, { "data-control": "uitk-toast", onSwiped: this.manuallyDismissToast }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames("uitk-toast-inner-wrapper"),
          ref: this.toastRef,
          onMouseEnter: this.clearTimer,
          onMouseLeave: this.startTimer,
          onFocus: this.clearTimer,
          onBlur: this.startTimer
        },
        /* @__PURE__ */ React.createElement("h4", { className: labelClasses }, children),
        action && /* @__PURE__ */ React.createElement("div", { className: actionBtnParentClass }, /* @__PURE__ */ React.createElement(
          UitkTertiaryButton,
          {
            type: "button",
            onClick: this.manuallyDismissToast,
            onMouseEnter: this.clearTimer,
            onMouseLeave: this.startTimer,
            onFocus: this.clearTimer,
            onBlur: this.startTimer,
            className: classNames("uitk-toast-button"),
            domRef: this.actionRef
          },
          actionText
        ))
      ))
    );
  }
}
